import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/accessibility.css';
import './styles/keyboard-navigation.css';

// Register service worker for PWA functionality
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // The service worker is automatically generated by vite-plugin-pwa
    // It will be registered at /colombia_department_puzzle/sw.js
    navigator.serviceWorker
      .register('/colombia_department_puzzle/sw.js', {
        scope: '/colombia_department_puzzle/',
        updateViaCache: 'none', // Force SW to always check for updates
      })
      .then((registration) => {
        // Check for updates periodically (every hour)
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);

        // Listen for new service worker installation
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (
                newWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                // New content available, notify user via custom event
                window.dispatchEvent(
                  new CustomEvent('swUpdateAvailable', {
                    detail: { registration },
                  })
                );
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('PWA: Service Worker registration failed', error);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);